import camelcaseKeys from 'camelcase-keys'
import { mergeRight } from 'ramda'

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const queryStringToCamelcasedObject = (search = ``) =>
  camelcaseKeys(Object.fromEntries(new URLSearchParams(search)))

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

// eslint-disable-next-line import/prefer-default-export
export const addQueryParamsToInitialData = (initalData = {}) => {
  const params = queryStringToCamelcasedObject(window.location.search)
  return mergeRight(initalData, params)
}
